import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import SupportIcon from '@mui/icons-material/Support';
import { PathwordStoreType } from '../PathwordStore';
import { Store } from 'pullstate';

type LifelineButtonProps = {
  store: Store<PathwordStoreType>;
  onSave: () => void;
};

const LifelineButton = ({ store, onSave }: LifelineButtonProps) => {
  const { solved, hintLetters, enabledHints, hintsUsed, initialEnabledHints } = store.useState();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Calculate available lifeline hints (total hints minus initial hints)
  const totalLifelineHints = hintLetters.length - initialEnabledHints;
  const remainingHints = hintLetters.length - enabledHints.length;
  const allHintsUsed = remainingHints === 0;

  const useHint = () => {
    store.update(s => {
      // Find the next hint index to enable (smallest one not in enabledHints)
      const nextHintIndex = Array.from({ length: hintLetters.length }, (_, i) => i)
        .find(i => !s.enabledHints.includes(i));

      if (nextHintIndex !== undefined) {
        s.enabledHints = [...s.enabledHints, nextHintIndex].sort((a, b) => a - b);
        s.hintsUsed++;
      }
    });
    handleClose();
    setTimeout(onSave, 100);
  };

  return (
    <span>
      <IconButton
        id="lifelines"
        title="Lifelines"
        disabled={solved}
        onClick={handleClick}
      >
        <SupportIcon/>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem disabled={allHintsUsed} onClick={useHint}>
          Get hint ({hintsUsed}/{totalLifelineHints})
        </MenuItem>
      </Menu>
    </span>
  );
};

export default LifelineButton;
